<template lang="pug">
v-dialog(v-model="isInformationDialog" :max-width="960" persistent)

    div.informationWrapper
        p We notice you are using a mobile device. Chill Anywhere works best through the mobile app

        div(class="xs12 white--text")
            a.badge(href="https://apps.apple.com/ua/app/chill-anywhere/id1495305049" target="_blank" rel="noreferrer")
                img(src="https://s3.us-east-2.amazonaws.com/chillanywhere.com/market-badges/app_store_2x.png" alt="Applestore")
            a.badge(href="https://play.google.com/store/apps/details?id=chillanywhere.app" target="_blank" rel="noreferrer")
                img(src="https://s3.us-east-2.amazonaws.com/chillanywhere.com/market-badges/google_play_2x.png" alt="Playmarket")

        p Thank you!

        p
            // skip button
            button-component.mt-4.accept(
                :action="closeInformationDialog"
                color="grey"
                medium
                outline
            ) {{ $t('general.skip') }}
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Button from '~components/Button';
    import Separator from '~components/Separator';

    export default {
        components: {
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        computed: {
            ...mapGetters('modals', ['isInformationDialog', 'isWelcomeDialog'])
        },
        methods: {
            ...mapActions('modals', [
                'setInformationDialog',
                'setWelcomeDialog'
            ]),

            /**
             * Close Information Dialog
             */
            closeInformationDialog() {
                // Set informationDialog to false
                this.setInformationDialog();
                // Set isWelcomeDialog to true
                this.setWelcomeDialog();
                window.localStorage.setItem('welcomeDialog', new Date());
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl";

    .informationWrapper
        padding: 40px 20px
        background-color: #022341
        text-align: center

        div
            padding 10px 0 25px

    p
        font-size: 16px

    .badge
        display: inline-block
        margin: 5px

        img
            height: 40px
</style>
